window.swatches = {
    'Medium Brown': '#4D3117',
    Black: 'black',
    'Light Brown': '#744928',
    'Dark Brown': '#291A10',
};

const imgResize = (value, size) => {
    if (value == null) return;
    let type = value.split('.').pop();
    return value.replace('.' + type, '_' + size + '.' + type);
};

const createSwatches = (product, wrapperID) => {
    let optionIndex = undefined;

    for (let i = 0; i < product.options.length; i++) {
        if (product.options[i] && product.options[i].toString().toLowerCase() == 'color') {
            optionIndex = i;
            break;
        } else if (product.options[i].name && product.options[i].name.toString().toLowerCase() == 'color') {
            optionIndex = i;
            break;
        } else {
            document.querySelector(wrapperID + ' #swatches-wrapper').classList.add('hidden');
            document.querySelector(wrapperID + ' .selected-color').classList.add('hidden');
            return;
        }
    }

    if (optionIndex !== undefined) {
        let selectWrapper = document.querySelector(wrapperID + ' #js-select-' + product.id + '-option-' + optionIndex),
            selectOptions = selectWrapper.getElementsByTagName('option'),
            swatchesWrapper = document.querySelector(wrapperID + ' #swatches-wrapper');

        selectWrapper.closest('.selector-wrapper').classList.add('hidden');

        for (let i = 0; i < selectOptions.length; i++) {
            let node = document.createElement('div'),
                selectedClass = selectWrapper.value == selectOptions[i].value ? ' selected' : '',
                bgColor = window.swatches[selectOptions[i].value],
                imgBg = null;

            if (bgColor == undefined) {
                let pVar = product.variants.filter(
                    (v) => v.title.indexOf(selectOptions[i].value) > -1 && v.featured_image
                )[0];
                imgBg = pVar ? pVar.featured_image.src : product.featured_image;
            }

            //node.setAttribute('href', '/products/' + product.handle)
            node.setAttribute('class', 'swatch-item' + selectedClass);
            node.setAttribute('data-name', selectOptions[i].value);
            node.setAttribute('aria-label', selectOptions[i].value);
            node.setAttribute('data-index', i);

            if (imgBg == null) {
                node.setAttribute('style', 'background-color: ' + bgColor + ';');
            } else {
                node.setAttribute('style', 'background-image: url(' + imgResize(imgBg, '100x') + ');');
            }

            swatchesWrapper.append(node);
        }

        let swatchItems = document.querySelectorAll(wrapperID + ' .swatch-item'),
            swatchSelector = '.swatch-item';

        swatchesWrapper.addEventListener('click', (e) => {
            e.preventDefault();

            let closest = e.target.closest(swatchSelector);

            if (closest && swatchesWrapper.contains(closest)) {
                for (let swatch of swatchItems) {
                    swatch.classList.remove('selected');
                }

                closest.classList.add('selected');

                selectWrapper.value = closest.dataset.name;

                let event = new Event('change');
                selectWrapper.dispatchEvent(event);
            }
        });

        document.querySelector(wrapperID + ' #swatches-wrapper').classList.remove('hidden');
    }
};
